import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useReceivingStore } from 'store/receiving'

export const useReceiveWorkflowLogic = () => {
  const activeStep = useReceivingStore((s) => s.activeStep)
  const setActiveStep = useReceivingStore((s) => s.setActiveStep)
  const resetWorkflow = useReceivingStore((s) => s.resetWorkflow)
  const setIsNavigationBlocked = useReceivingStore(
    (s) => s.setIsNavigationBlocked
  )
  const ownershipType = useReceivingStore((s) => s.ownershipType)
  const productType = useReceivingStore((s) => s.productType)
  const undocumentedCount = useReceivingStore((s) => s.undocumentedItems.length)
  const documentedCount = useReceivingStore((s) => s.documentedItems.length)

  const navigate = useNavigate()
  const [isDiscardAlertOpen, setIsDiscardAlertOpen] = useState(false)

  const steps = ['Ownership', 'Product Type', 'Capture Items', 'Review & Save']

  const handleStepClick = (stepIndex: number) => {
    if (stepIndex < activeStep) setActiveStep(stepIndex)
  }

  const handleNextStep = () => {
    if (activeStep < steps.length - 1) setActiveStep(activeStep + 1)
  }

  const handlePreviousStep = () => {
    if (activeStep > 0) setActiveStep(activeStep - 1)
  }

  const handleDiscardWorkflow = () => {
    resetWorkflow()
    setIsDiscardAlertOpen(false)
    setTimeout(() => navigate('/surgeries'), 0)
  }

  const handleLeaveWorkflow = () => {
    resetWorkflow()
  }

  const blocked = Boolean(
    ownershipType !== null ||
      productType !== null ||
      undocumentedCount > 0 ||
      documentedCount > 0
  )

  useEffect(() => {
    setIsNavigationBlocked(blocked)
  }, [blocked, setIsNavigationBlocked])

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (blocked) {
        event.preventDefault()
        event.returnValue =
          'You have unsaved changes. Are you sure you want to leave?'
        return event.returnValue
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [blocked])

  return {
    activeStep,
    steps,
    isDiscardAlertOpen,
    handleStepClick,
    handleNextStep,
    handlePreviousStep,
    handleDiscardWorkflow,
    handleLeaveWorkflow,
    setIsDiscardAlertOpen,
  }
}
